import React, { useContext, useState } from "react";
import { API } from "../../Table";
import { Form } from "antd";
import { ModalForm } from "src/enitities/Modal";
import { OrganizationsForm, serializeTimestamp } from "src/enitities/Form";
import { OrganizationsContext } from "src/shared/lib/hooks/context/getOrganizationsContext";

export default function AddOrganizations({ isOpen, setOpen }) {
  const [changeData, setChangeData] = useState(false);
  const { token, pathname } = useContext(OrganizationsContext);
  const [form] = Form.useForm();
  const handleSubmit = async (data) => {
    const queryCreate = API.crud.create(token, pathname);
    const newData = serializeTimestamp(data[0], "registration_date");
    try {
      await queryCreate(newData);
      return true;
    } catch (err) {
      return Promise.reject(err.message.detail);
    }
  };

  return (
    <ModalForm
      title={"Добавить организацию"}
      isOpen={isOpen}
      setOpen={setOpen}
      formContext={form}
      handleSubmit={handleSubmit}
      changeData={changeData}
      setChangeData={setChangeData}
    >
      <OrganizationsForm formContext={form} setChangeData={setChangeData} />
    </ModalForm>
  );
}
